import { createAction } from '@reduxjs/toolkit';

import { createPromiseAction } from 'app/utils/promiseActions';

import {
  CreateWebsocketPayload,
  CreateWebsocketResponse,
  WebsocketError,
} from '../types';
import { WebsocketRequestMessage } from '../types/outboundWebsocketEvent';

const prefix = 'webSocket';

export const websocketActions = {
  request: createPromiseAction<WebsocketRequestMessage, unknown>(
    `${prefix}/request`,
  ),
  requestFulfilled: createAction(`${prefix}/request/fulfilled`),
  requestRejected: createAction(`${prefix}/request/rejected`),

  requestSent: createAction(`${prefix}/requestSent`),

  create: createPromiseAction<CreateWebsocketPayload, CreateWebsocketResponse>(
    `${prefix}/create`,
  ),
  createFulfilled: createAction<CreateWebsocketResponse>(
    `${prefix}/createFulfilled`,
  ),
  createRejected: createAction<Event | undefined>(`${prefix}/create/rejected`),
  close: createAction(`${prefix}/close`),

  reconnectAttempt: createAction(`${prefix}/reconnectAttempt`),

  replyReceived: createAction<unknown>(`${prefix}/replyReceived`),
  eventReceived: createAction<unknown>(`${prefix}/eventReceived`),
  errorReceived: createAction<WebsocketError>(`${prefix}/errorReceived`),

  closeReceived: createAction(`${prefix}/closeReceived`),

  cancelReconnect: createAction(`${prefix}/cancelReconnect`),
  reconnectFailed: createAction(`${prefix}/reconnectFailed`),

  connectionPrimary: createAction<boolean>(`${prefix}/connectionPrimary`),
};

export type WebsocketRequestAction = ReturnType<
  typeof websocketActions.request
>;
export type WebsocketCreateAction = ReturnType<typeof websocketActions.create>;
